(function (window, document, undefined) {
  
  
  // Snippet - Video
  var sn_videos_posters = document.querySelectorAll('.sn_video .poster');
  if( sn_videos_posters.length) {
    [].forEach.call(sn_videos_posters, function(e, index) {
      e.addEventListener('click', function(){
        e.closest('.item').querySelector('video').play();
        e.remove();
      });
    });
  }


  window.chcekSnVideos = function () {
    // Pause video if container is display:none
    
    var sn_videos_v = document.querySelectorAll('.sn_video video');
    if (sn_videos_v.length) {
      [].forEach.call(sn_videos_v, function(e, index) {
        var item_style = getComputedStyle(e.closest('.item'));
        if (item_style.display == 'none') {
          e.pause();
        }
      });
    } 
  }


  window.onResize = function () {
    window.chcekSnVideos();
  };


  window.addEventListener('resize', window.onResize);

})(window, window.document);
